import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  text-align: center;
  margin: 4em 0;
  margin-left: auto;
  margin-right: auto;
  

  .submitBtn{
    border-width: 0;
    height: 38px;
    width: 100%;
    background-color: rgba(60, 211, 207, 1);
    border-radius: 22px;
  }
  div {
    font-family: 'Montserrat';
    cursor: pointer;
    display: inline;
  }
    height: 38px;
    width: 300px;
    background-color: rgba(60, 211, 207, 1);
    border-radius: 19px;
    line-height: 38px;
    text-align: center;
    font-family: 'Montserrat';
    font-size: 15px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    letter-spacing: 0.01em;
`;

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/MainButton/Wrapper.js